import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpCancelService {
  private pendingHTTPRequests$ = new Subject<void>();

  constructor() {}

  // Cancel Pending HTTP calls
  public cancelPendingRequests(): void {
    this.pendingHTTPRequests$.next();
  }

  public onCancelPendingRequests(): Observable<any> {
    return this.pendingHTTPRequests$.asObservable();
  }
}
